import { useSelector } from 'react-redux';

//@ts-ignore
import useCoreTimer from '@web-solutions/core/hooks/use-timer';
import { selectNoFundsOfferEndDate } from '@web-solutions/core/store/billing/selectors';
import { formatToStringForTimer } from '@web-solutions/core/utils/format-to-string-for-timer';

export const useNoFundsTimer = () => {
  const date = useSelector(selectNoFundsOfferEndDate);
  const { minutes, seconds } = useCoreTimer(date);

  return {
    shown: !!date,
    ended: minutes < 0 || seconds < 0,
    time: date ? `${formatToStringForTimer(minutes)}:${formatToStringForTimer(seconds)}` : '',
  };
};
